export default __webpack_public_path__ + "static/media/circle_check.762063c4.svg";